/** Seconds-before-end thresholds, highest first. */
export const SEASON_END_WARNING_THRESHOLDS = Object.freeze([
  { tier: '1h', atSeconds: 60 * 60 },
  { tier: '30m', atSeconds: 30 * 60 },
  { tier: '15m', atSeconds: 15 * 60 },
]);

/**
 * Next warning threshold the client will cross as time counts down.
 * Must be the highest threshold still strictly below secondsUntilEnd
 * (e.g. 31 minutes left → 30m in ~1 minute, not 15m).
 *
 * @param {number} secondsUntilEnd
 * @returns {{ tier: string, atSeconds: number } | null}
 */
export function nextUpcomingThreshold(secondsUntilEnd) {
  if (secondsUntilEnd == null || secondsUntilEnd <= 0) {
    return null;
  }
  for (const threshold of SEASON_END_WARNING_THRESHOLDS) {
    if (secondsUntilEnd > threshold.atSeconds) {
      return threshold;
    }
  }
  return null;
}
